var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUnlock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unlock-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53854 3.04381C8.98804 2.64716 8.37596 2.48472 7.74072 2.5488C7.09701 2.61448 6.5757 2.84403 6.08186 3.38867C5.67001 3.84288 5.41667 4.39149 5.41667 5.12244V7.03911H12.6667C13.8173 7.03911 14.75 7.97185 14.75 9.12244V13.7891C14.75 14.9397 13.8173 15.8724 12.6667 15.8724H3.33333C2.18274 15.8724 1.25 14.9397 1.25 13.7891V9.12244C1.25 7.97185 2.18274 7.03911 3.33333 7.03911H3.91667V5.12244C3.91667 3.98834 4.32999 3.08765 4.97064 2.3811C5.73066 1.54291 6.60281 1.15702 7.58895 1.0565C8.59848 0.954528 9.57526 1.22145 10.4154 1.82682C11.1936 2.38751 11.7999 3.31283 12.0017 4.30653C12.0841 4.71246 11.8218 5.10835 11.4159 5.19078C11.01 5.2732 10.6141 5.01095 10.5317 4.60502C10.4045 3.97851 10.0083 3.38226 9.53854 3.04381ZM3.33333 8.53911C3.01117 8.53911 2.75 8.80028 2.75 9.12244V13.7891C2.75 14.1113 3.01117 14.3724 3.33333 14.3724H12.6667C12.9888 14.3724 13.25 14.1113 13.25 13.7891V9.12244C13.25 8.80028 12.9888 8.53911 12.6667 8.53911H3.33333Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unlock.ee89a405.svg";
export { ForwardRef as ReactComponent };